import React, { FC } from 'react';
import { renderParagraphs } from '@lib/utils';
import { TextSectionT } from '@factories/RowFactory/components/TextSection/types';
import { StyledTextSection } from '@factories/RowFactory/components/TextSection/styled/StyledTextSection';

export const TextSection: FC<TextSectionT> = ({
  display,
  title,
  highlightText,
  subHighlight,
  description,
  alignment,
}) => {
  if (!display) return null;

  return (
    <StyledTextSection alignment={alignment}>
      {title && <h2>{title}</h2>}
      {highlightText && <h3>{highlightText}</h3>}
      {subHighlight && <div className="sub-highlight">{subHighlight}</div>}
      {description && (
        <div className="description">
          {renderParagraphs({ body: description, hasMarkdown: true })}
        </div>
      )}
    </StyledTextSection>
  );
};

export default TextSection;
